import { useMutation } from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import { queryClient } from 'providers';

import { EventsApiService } from '../api/events-api.service';
import { eventsQueryKeys } from './query-keys';

const { createResultPDF } = EventsApiService();

export const useCreateResultPDF = () => {
    const { message } = App.useApp();

    return useMutation(
        ({ id, formData }: { id: string, formData: FormData }) => {
            return createResultPDF(id, formData);
        },
        {
            onError: (error) => {
                const uiMessage = handleError(error);

                message.error(uiMessage);
            },
            onSuccess: () => {
                queryClient.invalidateQueries({
                    queryKey: eventsQueryKeys.all,
                });
                message.success("Result PDF uploaded successfully");
            },
        },
    );
};
